<div class="back-btn exit-app" (click)="onBack()"></div>
<div
  class="tv-vertical-wrapper"
  [ngClass]="{ 'menu-open': isMenuOpen }"
  *ngIf="showVerticalNav"
>
  <div
    [ngClass]="{ 'vertical-focusable-container': isNavActive }"
    class="tv-vertical-menu vertical-focusable-container"
    (keydown.arrowRight)="isNavActive ? focusRight() : null"
  >
    <ng-container
      *ngFor="let item of menuItems; let i = index; trackBy: trackByMenuItemId"
    >
      <app-icon-button
        *ngIf="item?.id === MENU_ITEM_IDS.SUBSCRIBE && showPlanAction !== null"
        [label]="getTranslatedSubscriptionName() | translate | uppercase"
        [mode]="showPlanAction"
        width="18vw"
        height="7.5vh"
        class="subscribe"
        [style.opacity]="isMenuOpen ? '1' : '0'"
        (click)="onSubscribe()"
        [tabindex]="i"
        [ngClass]="{
          'menu-open': isMenuOpen,
          focused: i === selectedIndex || i === focusedIndex
        }"
        (focusin)="onFocus(i)"
        (focusout)="onFocus(i, false)"
      ></app-icon-button>
      <button
        *ngIf="item?.id !== MENU_ITEM_IDS.SUBSCRIBE"
        class="primary-button tv-vertical-menu-item focusable-element"
        [tabindex]="i"
        (click)="onClick(i)"
        [ngClass]="{
          'menu-open': isMenuOpen,
          'selected-item': i === selectedIndex,
          focused: i === selectedIndex || i === focusedIndex
        }"
        (focusin)="onFocus(i)"
        (focusout)="onFocus(i, false)"
      >
        <div class="icon-wrapper">
          <app-icon
            [isVerticalNav]="true"
            [icon]="item?.icon"
            [isMenuActive]="isMenuActive"
            [isSelected]="i === selectedIndex"
            [isFocused]="i === focusedIndex"
          ></app-icon>
          <div
            class="icon-container-selected"
            [class.show-icon]="i === selectedIndex && i !== focusedIndex"
          ></div>
        </div>
        <span
          *ngIf="isMenuOpen"
          class="tv-vertical-menu-item-text"
          [style]="
            i === selectedIndex
              ? ('fontSize.28' | translate)
              : ('fontSize.24' | translate)
          "
          [ngClass]="{ 'selected-item': i === selectedIndex }"
          >{{ item?.name | translate }}</span
        >
      </button>
    </ng-container>
  </div>
</div>
<div class="page-container container-all">
  <app-shimmer-router-outlet></app-shimmer-router-outlet>
  <!-- <router-outlet></router-outlet> -->
</div>
